import { gql } from '@ori/fetching';

export const subscribeToBackInStockNotification = gql`
  mutation SubscribeToBackInStock($input: BackInStockNotificationSubscriptionInput!) {
    backInStockNotificationSubscription(input: $input)
  }
`;
